import React, { useState, useEffect } from "react";
import { Button, Row, Col, Input, Form } from "antd";
import { useTranslation } from "react-i18next";

import Api from "../../../api";

import { Filters } from "../../../components/Drawer/SocialMedia/Filters";
import CreateSocialMedia from "../../../components/Drawer/SocialMedia/CreateSocialMedia";
import EditSocialMedia from "../../../components/Drawer/SocialMedia/EditSocialMedia";
import SocialMediaTable from "../../../components/Tables/SocialMedia";
import { toastNotification } from "../../../utils/toastNotification";

const SocialMediaContainer = () => {
  const [t, i18n] = useTranslation();
  const [form] = Form.useForm();
  const [isVisibleCreate, setVisibleCreate] = useState(false);
  const [generalInfo, setGeneralInfo] = useState([]);

  const [modalState, setModal] = useState({ id: "", mode: "", isOpen: false });
  const [loading, setLoading] = useState(true);
  const [social_media, setSocialMedias] = useState([]);
  const [editData, setData] = useState([]);
  const [isEdit, setEdit] = useState(false);

  const handleModal = (mode, isOpen, id) => {
    setModal({
      ...modalState,
      ["mode"]: mode,
      ["isOpen"]: isOpen,
      ["id"]: id,
    });
  };

  useEffect(() => {
    handleGetAllSocialMedias();
  }, []);

  const handleGetAllSocialMedias = () => {
    Api("generals/type/social-media", "GET")
      .then((data) => {
        if (!data) {
          toastNotification("info", "Please add general information first!");
          setVisibleCreate(false);
          setLoading(false);
        } else {
          setGeneralInfo(data);
          setVisibleCreate(true);
          form.setFieldsValue(data);

          setSocialMedias(data?.social_media);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getSupportById = (id) => {
    setLoading(true);
    Api("social-media/" + id, "GET", null)
      .then((data) => {
        setData(data);
        handleModal("edit", true, id);
        setLoading(false);
      })
      .catch((err) => {
        toastNotification("error", err.error || "Something went wrong!");
        setLoading(false);
      });
  };

  const deleteSupport = (id) => {
    if (!id) return message.error("Id is missing!");
    Api("social-media/" + id, "DELETE", null)
      .then(() => {
        toastNotification("success", "Support was successfully deleted");
        handleGetAllSocialMedias();
      })
      .catch(() =>
        toastNotification("error", "Error while deleting social_media")
      );
  };

  const handleSubmitGeneralForm = (values) => {
    if (!generalInfo.length && !generalInfo?.social_media?.length) {
      values.type = "social-media";
      Api("generals/", "POST", values)
        .then((data) => {
          setLoading(false);
          setGeneralInfo(data);
          setVisibleCreate(true);
          form.setFieldsValue(data);
        })
        .catch((err) => {
          toastNotification("error", err.error || "Something went wrong!");
          setLoading(false);
        });
    } else {
      Api("generals/" + generalInfo.id, "PATCH", values)
        .then((data) => {
          setLoading(false);
          setGeneralInfo(data);
          form.setFieldsValue(data);
        })
        .catch((err) => {
          toastNotification("error", err.error || "Something went wrong!");
          setLoading(false);
        });
    }
  };

  return (
    <div className="articles-container">
      <div className="header">
        <Filters />
        <Button
          className="button"
          onClick={() => handleModal("create", true)}
          disabled={!isVisibleCreate}
        >
          {t("add_social_media")}
        </Button>
      </div>
      <CreateSocialMedia
        onClose={handleModal}
        isVisible={modalState.mode == "create" && modalState.isOpen}
        handleGetAllSocialMedias={handleGetAllSocialMedias}
        social_media={social_media}
        generalId={generalInfo.id}
      />
      <EditSocialMedia
        data={editData}
        id={modalState.id}
        isVisible={modalState.mode == "edit" && modalState.isOpen}
        handleGetAllSocialMedias={handleGetAllSocialMedias}
        onClose={handleModal}
        social_media={social_media}
      />
      <div style={{ paddingTop: 30, paddingBottom: 10 }}>
        <Form
          form={form}
          id="general-form"
          layout="vertical"
          scrollToFirstError
          onFinish={(values) => !isEdit && handleSubmitGeneralForm(values)}
        >
          <Row>
            <Col span={8}>
              <Form.Item
                name="title"
                label={t("Title")}
                style={{ marginRight: 10 }}
                rules={[{ required: true, message: `${t("Title")}` }]}
              >
                <Input placeholder="Title" disabled={!isEdit} />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button
                key="submit"
                htmlType="submit"
                className="button"
                form="general-form"
                style={{ marginLeft: 15, marginTop: 28.5 }}
                onClick={() => setEdit(!isEdit)}
              >
                {t(!isEdit ? "Bearbeiten" : "save")}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>

      <SocialMediaTable
        getSupportById={getSupportById}
        deleteSupport={deleteSupport}
        social_media={social_media}
        loading={loading}
      />
    </div>
  );
};
export default SocialMediaContainer;
